module.exports = __webpack_public_path__ + "static/1-Underseacable-1858-3646ef16b3d12792b10265050988f05d.jpg";